import LockIcon from '@mui/icons-material/Lock'
import { Box, Button, Typography } from '@mui/material'
import { FC } from 'react'
import { useTranslate } from 'react-admin'
import { useNavigate } from 'react-router-dom'

const Unauthorized: FC = () => {
  const translate = useTranslate()
  const navigate = useNavigate()

  return (
    <Box sx={{ p: 4, textAlign: 'center', mt: 8 }}>
      <LockIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
        {translate('page.unauthorized.title')}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        {translate('page.unauthorized.text')}
      </Typography>
      <Button variant="contained" onClick={() => navigate('/')}>
        Terug naar dashboard
      </Button>
    </Box>
  )
}

export default Unauthorized
